import React, {useEffect, useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import GamesListRow from "./GamesListRow";
import {Tab, Tabs} from "react-bootstrap";
import PersonalGamesListRow from "./PersonalGamesListRow";
import GroupGamesListRow from "./GroupGamesListRow";
import {useTranslation} from "react-i18next";
import PageTipsGamesList from "../PageTipsGamesList";

function GamesList(props) {
    const [individualGamesState, setIndividualGamesState] = useState();
    const [selfGamesState, setSelfGamesState] = useState();
    const [groupGamesState, setGroupGamesState] = useState();
    const [key, setKey] = useState(props.selectedGameType || 'individualGames');
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'gamesListPage'});

    let numberOfSelfGames = selfGamesState?.length;
    let numberOfSelfFinishedGames = selfGamesState?.filter(game => game.is_over)?.length;

    let numberOfIndividualGames = individualGamesState?.length;
    let numberOfIndividualFinishedGames = individualGamesState?.filter(game => game.is_over)?.length;

    let numberOfGroupGames = groupGamesState?.length;
    let numberOfGroupFinishedGames = groupGamesState?.filter(game =>
        game.players?.filter(player => !player.is_over)?.length === 0
    )?.length;

    function filterIndividualGames(allGames, newGames, startedGames, finishedGames, searchText) {
        let gamesList = props.gameState?.filter(game => !game.is_self_game)
        setIndividualGamesState(filterGames(gamesList, allGames, newGames, startedGames, finishedGames, searchText))
    }

    function filterSelfGames(allGames, newGames, startedGames, finishedGames, searchText) {
        let gamesList = props.gameState?.filter(game => game.is_self_game)
        setSelfGamesState(filterGames(gamesList, allGames, newGames, startedGames, finishedGames, searchText))
    }

    function filterGames(gamesList, allGames, newGames, startedGames, finishedGames, searchText) {
        let filteredGames = gamesList

        if (newGames) {
            filteredGames = gamesList?.filter(game => !game.is_started && !game.is_over)
        } else if (startedGames) {
            filteredGames = gamesList?.filter(game => game.is_started && !game.is_over)
        } else if (finishedGames) {
            filteredGames = gamesList?.filter(game => game.is_over)
        }
        return (typeof searchText !== undefined && searchText?.length > 0)
            ? filteredGames?.filter(
                game => game.player_name.toLowerCase().includes(searchText.toLowerCase())
                    || game.name.toLowerCase().includes(searchText.toLowerCase()))
            : filteredGames

    }

    function filterGroupGames(allGames, newGames, startedGames, finishedGames, searchText) {
        let gamesList = props.groupGamesList
        let filteredGames = gamesList

        if (newGames) {
            filteredGames = gamesList?.filter(game => !game.is_started && game.players?.filter(player => !player.is_over)?.length !== 0)
        } else if (startedGames) {
            filteredGames = gamesList?.filter(game => game.is_started && game.players?.filter(player => !player.is_over)?.length !== 0)
        } else if (finishedGames) {
            filteredGames = gamesList?.filter(game => game.players?.filter(player => !player.is_over)?.length === 0)
        }
        let res = (typeof searchText !== undefined && searchText?.length > 0)
            ? filteredGames?.filter(
                game => game.players.filter(player => player.name.toLowerCase().includes(searchText.toLowerCase())).length > 0
                    || game.name.toLowerCase().includes(searchText.toLowerCase()))
            : filteredGames
        setGroupGamesState(res)
    }

    useEffect(() => {
        setIndividualGamesState(props.gameState?.filter(game => !game.is_self_game))
        setSelfGamesState(props.gameState?.filter(game => game.is_self_game))
    }, [props.gameState]);

    useEffect(() => {
        setGroupGamesState(props.groupGamesList)
    }, [props.groupGamesList]);

    return (
        <>
            {/*<Banner></Banner>*/}
            <div className={cabinetStyle.mainPageContainer}>
                <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                    fill
                    style={{
                        width: "660px",
                        fontWeight: "bold"
                    }}
                >
                    <Tab eventKey="individualGames" title={t('individualTab')}>
                        <PageTipsGamesList finished={numberOfIndividualFinishedGames}
                                           allGames={numberOfIndividualGames}
                                           filterGameTypes={filterIndividualGames}>
                        </PageTipsGamesList>
                        {individualGamesState?.map((game,index) => {
                            return <GamesListRow description={index === 0} key={game.id} game={game} updataGames={props.updateGames}
                                                 updateBalance={props.updateBalance}></GamesListRow>
                        })}
                    </Tab>
                    <Tab eventKey="groupGames" title={t('groupTab')}>
                        <PageTipsGamesList finished={numberOfGroupFinishedGames}
                                           allGames={numberOfGroupGames}
                                           filterGameTypes={filterGroupGames}>
                        </PageTipsGamesList>
                        {groupGamesState?.map((game, index) => {
                            return <GroupGamesListRow
                                description={index === 0}
                                key={game.id}
                                game={game}
                                updateGames={props.updateGroupGames}
                                freeTier={props.freeTier}
                                currentBalance={props.currentBalance}
                                updateBalance={props.updateBalance}/>
                        })}
                    </Tab>
                    <Tab eventKey="privateGames" title={t('personalTab')}>
                        <PageTipsGamesList finished={numberOfSelfFinishedGames}
                                           allGames={numberOfSelfGames}
                                           filterGameTypes={filterSelfGames}>
                        </PageTipsGamesList>
                        {selfGamesState?.filter(game => game.is_self_game).map(game => {
                            return <PersonalGamesListRow game={game} key={game.id}
                                                         updataGames={props.updateGames}
                                                         updateBalance={props.updateBalance}></PersonalGamesListRow>
                        })}
                    </Tab>
                </Tabs>
            </div>
        </>

    )
}

export default GamesList